<template>
    <AppTabLinks :links="list" />
</template>

<script>
import AppTabLinks from '@/components/AppTabLinks';

export default {
    name: 'ShopCatalogTabLinks',

    components: {
        AppTabLinks
    },

    computed: {
        list() {
            return [
                {
                    title: 'Каталог',
                    url: '/shop-catalog',
                    exact: true
                },
                {
                    title: 'Выходные дни',
                    url: '/shop-catalog/holidays'
                },
                {
                    title: 'Обращения',
                    url: '/shop-catalog/feedback'
                }
            ];
        }
    }
};
</script>
